/**
 * /igaming-payment-hold — primary-slug route file for Feature #157.
 *
 * This file exists so the dash contract (D1) can resolve
 * `routes/igaming-payment-hold.tsx` for slug `igaming-payment-hold`. The
 * existing namespaced route in `igaming.payment-hold.tsx` holds the
 * breadcrumb + search-param parsing wrapper; we provide a plain primary
 * route that mounts `IgamingPaymentHoldPage` directly for the slug lane.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { IgamingPaymentHoldPage } from "@/features/igaming-payment-hold/IgamingPaymentHoldPage";

export const igamingPaymentHoldRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-payment-hold",
	component: IgamingPaymentHoldPage,
});

export default igamingPaymentHoldRoute;
